module.exports = __webpack_public_path__ + "img/mark-complete.b86f8907.svg";